import { useEffect, useState, useRef } from 'react';
import { Button, Col, Row } from 'antd';
import { utils } from '../../../utils/messageAlerts';
import WorkerInfoHeader from './PatientServicesPE/WorkerInfoHeader';
import PrestationsEditor from './PatientServicesPE/PrestationsEditor';

const PatientServicesPE = ({
  reservation,
  patientToAdmission,
  setPatientToAdmission,
  currentStep,
  setCurrentStep,
}) => {
  const companyReportType = reservation?.company?.report_type ?? null;
  const prestationsRef = useRef([]);

  const confirmRefreshPage = (event) => {
    event.preventDefault();
    event.returnValue = '¿Estás seguro que deseas abandonar?';
  };

  useEffect(() => {
    window.addEventListener('beforeunload', confirmRefreshPage);
    return () => window.removeEventListener('beforeunload', confirmRefreshPage);
  }, []);

  const handlePrestationsChange = (prestations) => {
    prestationsRef.current = prestations;
  };

  const handleNextStep = () => {
    const selectedPrestations = prestationsRef.current;

    if (selectedPrestations.length === 0) {
      utils.messageAlert('error', 'Debe seleccionar al menos 1 prestación');
      return;
    }

    const emptyBattery = selectedPrestations.find(prestation => {
      if (prestation.type === 'Exam') return false;
      const activeExams = prestation.battery_exams.filter(exam => !prestation.removedExamIds.includes(exam.id));
      return (activeExams.length + prestation.additionals.length) === 0;
    });

    if (emptyBattery) {
      utils.messageAlert(
        'error',
        `La batería "${emptyBattery.name}" no tiene exámenes. Agregue exámenes adicionales o elimínela del listado para continuar.`
      );
      return;
    }

    setPatientToAdmission(previousPatient => ({
      ...previousPatient,
      consents: null,
      prestations: selectedPrestations.map(prestation => ({
        id: prestation.id,
        name: prestation.name,
        type: prestation.type,
        sale_amount: prestation.sale_amount,
        original_sale_amount: prestation.original_sale_amount,
        price_fallback: prestation.price_fallback,
        currency_id: prestation.currency_id,
        department_id: prestation.department_id ?? 1,
        consents: prestation.consents,
        battery_exams: prestation.battery_exams,
        exam_type: prestation.exam_type ?? null,
        report_type: prestation.report_type ?? null,
        medical_form_type: prestation.medical_form_type ?? null,
        additionals: prestation.additionals,
        removedExamIds: prestation.removedExamIds,
        selectedKeywords: prestation.selectedKeywords,
        conditionalExams: prestation.conditionalExams,
        observations: prestation.observations,
        availableKeywords: prestation.availableKeywords,
        exams: [],
      })),
    }));
    setCurrentStep(2);
  };

  return (
    <Row justify="center" className="admission-settings__patient-form mt-50">
      <Col lg={18} xs={22}>
        <div className="form-wrapper pt-30 pb-30 pl-lg-70 pl-md-20 pl-sm-20 pl-xs-20 pr-lg-70 pr-md-20 pr-sm-20 pr-xs-20">
          <WorkerInfoHeader
            patientToAdmission={patientToAdmission}
            reservation={reservation}
          />

          <PrestationsEditor
            initialPrestations={
              patientToAdmission?.prestations !== undefined && patientToAdmission?.prestations !== null
                ? patientToAdmission.prestations
                : patientToAdmission?.preadmissionPrestations
            }
            branchOfficeId={reservation?.branch_office_id}
            companyReportType={companyReportType}
            companyId={reservation?.company_id}
            outsourcingId={reservation?.outsourcing_id}
            thirdPartyId={reservation?.third_company_id}
            evaluationType={patientToAdmission?.evaluation_type}
            patientData={patientToAdmission}
            addAttachedServices
            observacionesOtras={reservation?.observations || null}
            onPrestationsChange={handlePrestationsChange}
          />
        </div>

        <Row justify="center">
          <Col lg={22} xs={24} className="mt-50 mb-60">
            <Row justify="end">
              <Col xl={3} lg={4} xs={24}>
                <Button
                  onClick={handleNextStep}
                  className="cmt-button primary"
                  type="primary"
                  size="large"
                  block
                >
                  Siguiente
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default PatientServicesPE;
